<script>
  import Pagination from '@/components/pagination/index.vue';
  import BaseListLayout from '@/views/layout/components/BaseListLayout.vue';
  import { myMixin } from '@/mixins/mixins.js';
  import { handleSortItem } from 'utils/utils';
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { checkStrNA, numToPercentStr } from '../../../utils/string';
  import { divideNumber, divideNumberPercent } from 'utils/number';
  import { getAdvReceiptEntityReport } from 'api/billing/advertiser/advReceiptEntityReport';
  import checkboxWatcher from '@/mixins/checkboxWatcher';

  export default {
    name: 'AdvEntityReport',
    components: {
      BaseListLayout,
      Pagination,
    },
    mixins: [myMixin, billingEnumMixins, financeInfoMixins, checkboxWatcher],
    data() {
      return {
        total: 0,
        listLoading: false,
        dataList: [],
        groupItemCheck: {
          advCompanyPlatformCheck: null,
          receiptDateCheck: null,
          advEntityCheck: null,
          hyperTapEntityCheck: null,
          receiptStatusCheck: null,
        },
        filter: {
          page: 1,
          pageSize: 10,
          advCompanyPlatformList: [],
          advEntityIdList: [],
          hyperTapEntityId: null,
          groupItems: [],
          recordDateRange: [],
          receiptDateRange: [],
          sortItems: [],
        },
      };
    },
    mounted() {
      this.handleSearch();
      this.checkboxConfig.targetArray = this.filter.groupItems;
      this.checkboxConfig.searchFunc = this.handleSearch;
    },
    methods: {
      numToPercentStr,
      divideNumberPercent,
      divideNumber,
      checkStrNA,
      handleSizeChange(size) {
        this.filter.pageSize = size;
        this.handleSearch(1);
      },
      handleCurrentChange(currentPage) {
        this.filter.page = currentPage;
        this.handleSearch(currentPage);
      },
      handleSort(columnInfo) {
        const sortItem = handleSortItem(columnInfo);
        if (sortItem === '') {
          return;
        }
        this.filter.sortItems = [];
        this.filter.sortItems.push(sortItem);
        this.handleSearch(1);
      },
      handleSearch(page) {
        this.listLoading = true;
        if (page) {
          this.filter.page = page;
        }
        getAdvReceiptEntityReport(this.filter)
          .then((res) => {
            if (res) {
              const result = res.result;
              this.dataList = result.dataList;
              this.total = res.total;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.listLoading = false;
          });
      },
    },
  };
</script>

<template>
  <base-list-layout :title="'Adv Billing Entity Report'">
    <template #search>
      <el-form :inline="true" :model="filter" label-width="180px" ref="searchForm">
        <el-form-item label="Date">
          <el-date-picker
            v-model="filter.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            style="width:260px;"
            align="right"
            unlink-panels
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="monthPickerOptions"
          />
        </el-form-item>
        <el-form-item label="Receipt Date">
          <div class="row-multi-item">
            <el-date-picker
              v-model="filter.receiptDateRange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="monthrange"
              clearable
              style="width:260px;"
              align="right"
              unlink-panels
              range-separator="to"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="monthPickerOptions"
            />
            <el-checkbox v-model="groupItemCheck.receiptDateCheck" name="receipt_date" />
          </div>
        </el-form-item>
        <el-form-item label="Adv Company Platform">
          <div class="row-multi-item">
            <el-select
              v-model="filter.advCompanyPlatformList"
              filterable
              multiple
              clearable
              placeholder="please select"
              @change="handleCompanyPlatformChange(filter.advCompanyPlatformList)"
            >
              <el-option
                v-for="item in companyPlatformList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-checkbox
              v-model="groupItemCheck.advCompanyPlatformCheck"
              name="advertiser_company_platform"
            />
          </div>
        </el-form-item>
        <el-form-item label="Adv Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.advEntityIdList"
              ref="companyEntityOptions"
              filterable
              multiple
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in specificCompanyEntity"
                :key="item.id"
                :label="item.companyEntity"
                :value="item.id"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.advEntityCheck" name="advertiser_entity" />
          </div>
        </el-form-item>
        <el-form-item label="HyperTap Entity">
          <div class="row-multi-item">
            <el-select
              v-model="filter.hyperTapEntityId"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in hyperTapCompanyEntities"
                :key="item.bfiId"
                :label="item.companyEntityAlias"
                :value="item.bfiId"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.hyperTapEntityCheck" name="hyper_tap_entity" />
          </div>
        </el-form-item>
        <el-form-item label="Receipt Status">
          <div class="row-multi-item">
            <el-select
              v-model="filter.receiptStatus"
              filterable
              clearable
              placeholder="please select"
            >
              <el-option
                v-for="item in advFullReceiptStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-checkbox v-model="groupItemCheck.receiptStatusCheck" name="receipt_status" />
          </div>
        </el-form-item>
      </el-form>
    </template>
    <template #search-actions>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch(1)">Search</el-button>
    </template>
    <template #table>
      <el-table
        v-loading="listLoading"
        ref="tableRef"
        :data="dataList"
        highlight-current-row
        @sort-change="handleSort"
      >
        <el-table-column
          label="Date"
          prop="recordDate"
          fixed="left"
          align="center"
          width="120"
          key="recordStartDate"
        />

        <el-table-column
          label="Adv Company Platform"
          prop="advertiserCompanyPlatform"
          align="center"
          width="180"
          show-overflow-tooltip
          key="advertiserCompanyPlatform"
        />
        <el-table-column
          label="Adv Entity"
          prop="advertiserEntity"
          align="center"
          show-overflow-tooltip
          width="170"
          key="advertiserEntity"
        />

        <el-table-column
          label="HyperTap Entity"
          prop="hyperTapEntity"
          align="center"
          key="hyperTapEntity"
          width="160"
        >
          <template #default="scope">
            {{ getHyperTapCompanyAlias(scope.row.hyperTapEntity) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Conversion"
          prop="advertiserConversion"
          align="center"
          key="advertiserConversion"
          width="160"
          sortable="custom"
        />
        <el-table-column
          label="Adv Revenue"
          prop="advertiserRevenue"
          align="center"
          key="advertiserRevenue"
          width="140"
          sortable="custom"
        />
        <el-table-column
          label="Adv Deduction Amount"
          prop="advertiserDeductionAmount"
          align="center"
          key="advertiserDeductionAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Adv Cover Amount"
          prop="advertiserCoverAmount"
          align="center"
          key="advertiserCoverAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Adv Confirmed Amount"
          prop="advertiserConfirmedAmount"
          align="center"
          key="advertiserConfirmedAmount"
          width="220"
          sortable="custom"
        />
        <el-table-column
          label="Adv Confirmed Amount Rate"
          align="center"
          key="advConfirmedRevenueSettlementRate"
          width="250"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.advConfirmedRevenueSettlementRate) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Adv Hedge Amount"
          prop="advertiserHedgeAmount"
          align="center"
          key="advertiserHedgeAmount"
          width="180"
          sortable="custom"
        />
        <el-table-column
          label="Adv Actual Amount"
          prop="advertiserActualAmount"
          align="center"
          key="advertiserActualAmount"
          width="180"
          sortable="custom"
        />
        <el-table-column
          label="Finance received amount"
          prop="financeReceivedAmount"
          align="center"
          key="financeReceivedAmount"
          width="220"
          sortable="financeReceivedAmount"
        />
        <el-table-column
          label="Adv Confirmed Status"
          align="center"
          key="advReconciliationProgress"
          prop="advReconciliationProgress"
          width="280"
        >
          <template #default="scope">
            {{ getEnumLabel(reconciliationProgressList, scope.row.advReconciliationProgress) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Receipt Date"
          prop="receiptDate"
          align="center"
          key="receiptDate"
          width="160"
        />
        <el-table-column
          label="Receipt Status"
          prop="receiptStatus"
          align="center"
          key="receiptStatus"
          width="180"
        >
          <template #default="scope">
            {{ getEnumLabel(advFullReceiptStatusList, scope.row.receiptStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Received Confirmed Amount Rate"
          align="center"
          key="receivedConfirmedAmountRate"
          width="250"
        >
          <template #default="scope">
            {{ numToPercentStr(scope.row.financeReceivedAmountSettlementRate) }}
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #pagination>
      <pagination
        class="block pagePanel"
        :pageTotal="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="filter.pageSize"
        :currentPage="filter.page"
      />
    </template>
  </base-list-layout>
</template>

<style scoped lang="scss"></style>
